
export const permissionToSidebarMap = [
    { permission: "dashboard", sidebar: "Dashboard" },
    { permission: "client_add" || "client_edit", sidebar: "All Clients" },
    { permission: "apicreateinfo", sidebar: "Api Create Info" },
    { permission: "Strategy_Permission", sidebar: "Strategies" },
    { permission: "groupservice_Permission", sidebar: "Stock Group Services" },
    { permission: "trade_history_old", sidebar: "Trade History" },
    { permission: "trade", sidebar: "Trade" },
    { permission: "tradecalculation", sidebar: "Trade Calculation" },
    
];